import { gql } from '@apollo/client';

export const DELETE_CONTRACTOR = gql`
  mutation deleteContractor($id: ID!) {
    deleteContractor(id: $id)
  }
`;
